"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDictionaryField = void 0;
const dictionary_field_1 = require("../../../components/dictionary-field/dictionary-field");
const form_field_1 = require("./form-field");
exports.FormDictionaryField = (0, form_field_1.formFieldFactory)(dictionary_field_1.DictionaryField);
//# sourceMappingURL=form-dictionary-field.js.map